<style lang="less" scoped>
  @import "../../../vars.less";
  .button-container {
    padding: @space-normal @space-normal;
    background-color: #fff;
  }
  .update-time {
    margin: 0;
    color: @text-color-secondary;
    margin-top: @space-medium;
    font-size: 12px;
    font-style: italic;
    padding: 0 @space-normal;
    text-align: center;
  }
  .loading {
    display: inline-block;
  }
  .mode {
    padding-right: @space-small;
  }
</style>

<template>
  <div class="stock">
    <van-search left-icon=""
      v-model="number"
      :placeholder="currentMode === 'order' ? $t('请输入标准订货号') : $t('请输入物料号')">
      <span slot="label">
        <van-popover placement="bottom-start" :get-container="getContainer"
          v-model="showModePop" :offset="[-16, 8]"
          :actions="modeList"
          @select="pickMode">
          <template #reference>
            <span @click.stop="() => showModePop = !showModePop" class="mode">
              {{ currentModeName }}
              <van-icon name="arrow-down" />
            </span>
          </template>
        </van-popover>
      </span>
    </van-search>
    <div class="button-container">
      <van-button type="info" size="small" round block @click="query" >{{ $t('查询库存') }}</van-button>
      <p class="update-time">
        <span v-show="!updateDateLoading && updateDate">
          {{ $t('数据更新日期') }}:
        </span>
        <span v-show="!updateDateLoading">
          {{ updateDate || $t('暂无数据更新日期') }}
        </span>
        <van-loading v-if="updateDateLoading" class="loading" size="14px" />
      </p>
    </div>
  </div>
</template>

<script>
import { Search, Button, Toast, Loading, Popover, Icon } from 'vant'
export default {
  name: 'stock',
  components: {
    'van-search': Search,
    'van-button': Button,
    'van-loading': Loading,
    'van-popover': Popover,
    'van-icon': Icon
  },
  data () {
    return {
      number: '',
      updateDate: '',
      updateDateLoading: false,
      showModePop: false,
      modeList: [
        { text: this.$t('物料号'), name: 'material' },
        { text: this.$t('标准订货号'), name: 'order' }
      ],
      currentMode: 'material'
    }
  },
  watch: {
    currentMode () {
      this.number = ''
    }
  },
  computed: {
    currentModeName () {
      return this.modeList.find(it => it.name === this.currentMode).text
    }
  },
  methods: {
    query () {
      if (!this.number.trim()) {
        Toast(this.currentMode === 'order' ? this.$t('请输入标准订货号') : this.$t('请输入物料号'))
      } else {
        if (this.currentMode === 'order' && this.number.length < 6) {
          Toast(this.$t('标准订货号至少需要输入6位'))
          return
        }
        this.$router.push({
          name: 'stock-query-result',
          query: { number: this.number, mode: this.currentMode },
          params: {
            stackType: 'push'
          }
        })
      }
    },
    getUpdateDate () {
      this.$apis.order.getStockUpdateDate(
        loading => (this.updateDateLoading = loading)
      ).then(res => {
        if (res) this.updateDate = res
      })
    },
    pickMode (action) {
      this.currentMode = action.name
    },
    getContainer () { return window.document.body },
    closePop () {
      this.showModePop = false
    }
  },
  mounted () {
    window.document.body.addEventListener('touchend', this.closePop)
    window.document.body.addEventListener('click', this.closePop)
    this.getUpdateDate()
  },
  beforeDestroy () {
    window.document.body.removeEventListener('touchend', this.closePop)
    window.document.body.removeEventListener('click', this.closePop)
  }
}
</script>
